import { render, staticRenderFns } from "./loginRegister.vue?vue&type=template&id=6c759574&scoped=true&"
import script from "./loginRegister.vue?vue&type=script&lang=js&"
export * from "./loginRegister.vue?vue&type=script&lang=js&"
import style0 from "./loginRegister.vue?vue&type=style&index=0&id=6c759574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c759574",
  null
  
)

export default component.exports